import { keyframes } from "@mui/material/styles"
import { colors } from "themes/palette/colors"

const { whiteAlpha8, whiteAlpha18, whiteAlpha42 } = colors

export const createClassCueRowPulse = keyframes`
  0%,
  100% {
    background-color: ${whiteAlpha8};
    box-shadow: inset 0 0 0 1px ${whiteAlpha18};
  }
  50% {
    background-color: ${whiteAlpha18};
    box-shadow: inset 0 0 0 1px ${whiteAlpha42};
  }
`

export const createClassCuePlusPulse = keyframes`
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.22);
  }
`
